import React from 'react'

export default function ContactCard(props) {
    return (
        <div className="card" >
            <div className="icon" >
                {props.icon}
            </div>
            <div className="content">
                <h4>{props.text}</h4>
                {props.link}
            </div>
        </div>
    )
}
